import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class SlackAppModel extends ModeModelBase {
  override _name = 'slackApp';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override attributes = [
    { name: 'id', default: '' },
    { name: 'uid', default: '' },
    { name: 'email', default: '' },
    { name: 'nickname', default: '' },
    { name: 'team_id', default: '' },
    { name: 'team_name', default: '' },
    { name: 'team_url', default: '' },
    { name: 'created_at', default: '' },
    { name: 'is_ok', default: false },
    { name: 'state', default: '' },
    { name: 'installer_name', default: '' },
    { name: 'version', default: 'v1' },
  ];
  override hasMany = [{ name: 'channels' }];
}

@Injectable({ providedIn: 'root' })
export class SlackAppModelAccessor extends ModelAccessorBase<SlackAppModel> {
  override name = 'slackApp';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override createAttributes = ['channels'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.slackApp');
  }

  createModel(resource, opts?) {
    const model = new SlackAppModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
